// https://be-tripaider.onrender.com/api

export const API_CONFIG = {
  development: "http://localhost:5000/api",
  test: "http://localhost:5000/api",
  production: "https://be-tripaider.onrender.com/api",
};

export const LANGUAGES = [
  {
    display: 'English',
    value: 'en'
  },
  {
    display: 'हिंदी',
    value: 'hi'
  },
  {
    display: 'বাংলা',
    value: 'bn'
  },
  {
    display: 'मराठी',
    value: 'mr'
  },
  {
    display: 'తెలుగు',
    value: 'te'
  },
  {
    display: 'தமிழ்',
    value: 'ta'
  },
];

export const GOOGLE_RECAPTCHA_SITE_KEY = "6Lcx6eopAAAAANfAzlYJ2HoVyK6y6SYx7oXql746"
